// États de la carte : hors ligne, carte d'hier, serveur muet, hors de la zone couverte.
// Chacun dit ce qui se passe et ce qui marche encore ; jamais une erreur sans issue.
import type { IsoDate } from '../api/contract';
import { addDays, formatShort, todayInParis } from '../lib/dates';
import { IconCloudOff } from './icons';
import './status.css';

interface Props {
  online: boolean;
  /** Date réellement servie, quand ce n'est pas celle demandée (calcul de 6 h pas encore passé). */
  staleDate: IsoDate | null;
  /** Le serveur ne répond pas, ou pas de carte du tout sur ce téléphone. */
  failed: boolean;
  hasData: boolean;
  outOfZone: boolean;
  onRetry: () => void;
  onHome: () => void;
}

export function StatusBanner({ online, staleDate, failed, hasData, outOfZone, onRetry, onHome }: Props) {
  const items: { key: string; tone: 'info' | 'alerte'; text: string; action?: { label: string; run: () => void } }[] = [];
  if (!online) {
    items.push({
      key: 'hors-ligne',
      tone: 'info',
      text: hasData
        ? 'Hors ligne. Carte du jour en cache, sorties enregistrées sur le téléphone.'
        : 'Hors ligne, et pas encore de carte sur ce téléphone : ouvrez l’app une fois avec du réseau pour la garder.',
    });
  } else if (failed) {
    items.push({
      key: 'erreur',
      tone: 'alerte',
      text: hasData ? 'Le serveur ne répond pas : la carte affichée est la dernière reçue.' : 'Le serveur ne répond pas pour le moment.',
      action: { label: 'Réessayer', run: onRetry },
    });
  }
  if (staleDate) {
    items.push({ key: 'veille', tone: 'info', text: `${staleDate === addDays(todayInParis(), -1) ? 'Carte d’hier' : `Carte du ${formatShort(staleDate)}`} · mise à jour du matin en attente` });
  }
  if (outOfZone) {
    items.push({ key: 'hors-zone', tone: 'info', text: 'Cette zone n’est pas encore couverte.', action: { label: 'Revenir à la zone', run: onHome } });
  }
  if (!items.length) return null;
  return (
    <div className="bandeaux" role="status">
      {items.map((i) => (
        <p key={i.key} className={`bandeau bandeau-${i.tone}`}>
          {i.key === 'hors-ligne' && <IconCloudOff width={20} height={20} />}
          <span>{i.text}</span>
          {i.action && (
            <button type="button" className="bandeau-action" onClick={i.action.run}>
              {i.action.label}
            </button>
          )}
        </p>
      ))}
    </div>
  );
}
